import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeart = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M3.165 3.977C5.053 2.173 8.113 2.173 10 5.229c1.887-3.056 4.947-3.056 6.834-1.252 1.888 1.817 1.888 4.874 0 6.692L10 17.25l-6.835-6.581c-1.887-1.818-1.887-4.875 0-6.692Z"
	})]
});
const ForwardRef = forwardRef(SvgHeart);
export { ForwardRef as ReactComponent };
